import React, {useEffect, useState} from "react";
import {Scrollbar} from "react-scrollbars-custom";
import {Helmet} from "react-helmet";

import Popup from '../popup/Popup';
import Backdrop from '../backdrop/Backdrop';

import pageStyles from './Page.module.scss';
import popupStyles from '../popup/Popup.module.scss';


const Page = ({markdownRemark}) => {

    useEffect(() => {
        let pageImages = document.querySelectorAll('#page img');
        for (let img of pageImages) {
            img.addEventListener('click', onImgClick);
        }
        return () => {
            for (let img of pageImages) {
                img.removeEventListener('click', onImgClick);
            }
        };
    }, []);

    const [isImgZoomed, setIsImgZoomed] = useState(false);
    const [zoomedImg, setZoomedImg] = useState(null);

    const popupCloseHandler = () => {
        setIsImgZoomed(false);
        setZoomedImg(null);
    };

    const onImgClick = event => {
        setIsImgZoomed(true);
        setZoomedImg(event.target.src);
    };

    return (
        <div id = "page" className = {pageStyles.page}>
            <Scrollbar
                thumbYProps={{
                    renderer: props => {
                        const { elementRef, ...restProps } = props;
                        return <div {...restProps} ref = {elementRef} style = {{background: "#C4DEF5", cursor: "pointer"}}/>;
                    }
                }}
                trackYProps={{
                    renderer: props => {
                        const { elementRef, ...restProps } = props;
                        return <div
                            {...restProps}
                            ref = {elementRef}
                            style = {{
                                height: "calc(100% - 0.55rem)",
                                position: "absolute",
                                overflow: "hidden",
                                userSelect: "none",
                                right: 0,
                                width: "0.33rem",
                                top: 0
                            }}
                        />;
                    }
                }}
                style = {{width: "100%", height: "100%"}}
            >
                <Helmet>
                    <title>{`Semograph - ${markdownRemark.frontmatter.title}`}</title>
                </Helmet>
                <Backdrop show = {isImgZoomed}/>
                <Popup show = {isImgZoomed} onClosePopup = {popupCloseHandler}>
                    <img id = "popup-img" className = {popupStyles.popupImg} alt = "popup-img" src = {zoomedImg}/>
                </Popup>
                <h1>{markdownRemark.frontmatter.title}</h1>
                <div dangerouslySetInnerHTML = {{__html: markdownRemark.html}}></div>
            </Scrollbar>
        </div>
    )
};

export default Page;
